import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonitoringDialog = _resolveComponent("MonitoringDialog")

  return (_openBlock(), _createBlock(_component_MonitoringDialog, {
    visibility: _ctx.showMonitoringDialog,
    dataset: _ctx.selectedDataset,
    onClose: _ctx.closeDialog,
    onSave: _ctx.updateDatasetAndSave
  }, null, 8, ["visibility", "dataset", "onClose", "onSave"]))
}